import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_movimiento_empleado`);
  return response;
};

const getByType = async (move_type) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_movimiento_empleado/get/${move_type}`);
  return response;
};

const getByStatus = async (status) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_movimiento_empleado/status/${status}`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_movimiento_empleado/${id}`);
  return response;
};

const getByIdEmpleado = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_movimiento_empleado/kardex/${id}`);
  return response;
};

const uploadFile = async (payload) => {
  const response = await post(
    `${process.env.REACT_APP_SERVER}upload_files_empleado/upload-file`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response;
};

export { getAll, getByType, getById, getByStatus, uploadFile, getByIdEmpleado};
